<template>
  <v-dialog
    scrollable
    v-if="isDialog"
    v-model="isDialog"
    width="800px"
    @click:outside="closeDialog"
  >
    <v-card height="800px" max-height="80vh">
      <v-card-title>
        <v-img
          :src="getThumbnailUrl(feature.assets.tn400x400.href)"
          class="white--text align-end text-center"
          height="300px"
        >
          <v-card-title>
            <v-chip>
              {{ feature.id }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              target="_blank"
              rel="noopener noreferrer"
              :href="getOriginalUrl(feature.id)"
              icon
              dark
            >
              <v-icon>mdi-fullscreen</v-icon>
            </v-btn>
          </v-card-title>
        </v-img>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <h4>Caption:</h4>
          <p>{{ feature.properties["caption/abstract"] }}</p>
          <h4>Keywords:</h4>
          <v-chip-group :show-arrows="true">
            <v-chip
              dark
              color="green"
              v-for="k in feature.properties.keywords"
              v-bind:key="k"
              >{{ k }}</v-chip
            >
          </v-chip-group>
          <h4>Coordinates:</h4>
          <p>
            {{
              Math.round(feature.geometry.coordinates[1] * 1000) / 1000 +
              "° N, " +
              Math.round(feature.geometry.coordinates[0] * 1000) / 1000 +
              "° W"
            }}
          </p>
          <h4>Datetime:</h4>
          <p>
            {{
              new Date(feature.properties.datetime).toDateString() +
              ", " +
              new Date(feature.properties.datetime).toTimeString()
            }}
          </p>
          <h4>By-line:</h4>
          <p>{{ feature.properties["by-line"] }}</p>
          <h4>Credit:</h4>
          <p>{{ feature.properties["credit"] }}</p>
          <h4>Copyright:</h4>
          <p>{{ feature.properties["copyright notice"] }}</p>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog">
          Close<v-icon right>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
const HOST_ORIGINAL = process.env.VUE_APP_ORIGINAL_PHOTOS;
const HOST_THUMBNAILS = process.env.VUE_APP_THUMBNAILS;
export default {
  props: ["dialog", "feature"],
  data() {
    return {};
  },
  components: {},

  methods: {
    getThumbnailUrl(path) {
      return HOST_THUMBNAILS + path;
    },
    getOriginalUrl(path) {
      return HOST_ORIGINAL + path + ".jpg";
    },
    closeDialog() {
      this.$emit("update:dialog", !this.dialog);
    },
    async getImage(url) {
      const response = await axios.get(url);
      return response.data;
    },
  },
  computed: {
    isDialog() {
      return this.dialog;
    },
  },
};
</script>

<style>
</style>